import { useState } from 'react';
import { useCancelNonAttendanceApplication } from '@/components/AbsenceApplication/hooks/useCancelNonAttendanceApplication';
import { useNonAttendanceProperties } from '@/components/AbsenceApplication/hooks/useNonAttendanceProperties';
import type { NonAttendanceApplicationDetail } from '@/components/AbsenceApplication/types';
import { isTodayInPeriod } from '@/utils/date';

interface State {
  isCancelable: boolean;
  showConfirmDisclaimer: boolean;
  isConfirmOpen: boolean;
  isCanceling: boolean;
  setIsConfirmOpen: (isOpen: boolean) => void;
  confirmCancel: () => void;
}

export const useAbsenceCancelFlow = (
  application: NonAttendanceApplicationDetail | undefined,
): State => {
  const { data: properties } = useNonAttendanceProperties();
  const { mutate: cancelApplication, isPending: isCanceling } =
    useCancelNonAttendanceApplication();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const isCancelable =
    !!application && !application.isCanceled && !application.isExpired;
  const cateringRequest = application?.cateringRequest;
  const showConfirmDisclaimer =
    !!properties?.isCateringEnabled &&
    !!properties?.isRigaCateringEnabled &&
    !!cateringRequest?.isCateringCanceled &&
    isTodayInPeriod(
      cateringRequest.cateringPeriod.from,
      cateringRequest.cateringPeriod.to,
    );

  const confirmCancel = () => {
    if (!application) {
      return;
    }
    cancelApplication(application.id, {
      onSuccess: () => setIsConfirmOpen(false),
    });
  };

  return {
    isCancelable,
    showConfirmDisclaimer,
    isConfirmOpen,
    isCanceling,
    setIsConfirmOpen,
    confirmCancel,
  };
};
